
import React, { Component } from "react"


import {Editor } from '@tinymce/tinymce-react';
import Grid from "@material-ui/core/Grid"
import { ThemeProvider } from '@material-ui/core/styles';
import {TextareaAutosize, withStyles} from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Cookies } from "react-cookie"
import Snackbar from "@material-ui/core/Snackbar"
import Container from "./someCSS/msSMSHandler";

import { Redirect } from "react-router-dom"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"

import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableBody from "@material-ui/core/TableBody";
import {Multiselect} from "multiselect-react-dropdown";




const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      label: {
            direction: "rtl",
            width: "100%",
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },


      select: {
            searchBox: {
                  // To change search box element look
                  border: "none",
                  fontSize: "35px",
                  minheight: "50px",
            },
            inputField: {
                  // To change input field position or margin
                  margin: "5px",
            },
            chips: {
                  // To change css chips(Selected options)
                  background: "red",
            },
            optionContainer: {
                  // To change css for option container
                  border: "2px solid",
            },
            option: {
                  // To change css for dropdown options
                  color: "black",
            },
      },
      btnsearch: {
            [theme.breakpoints.up("md")]: {
                  width: "120px",
                  height: "40px",
                  fontSize: "15px",
            },
            width: "80px",
            height: "30px",
            fontSize: "13px",
            color: "white",
            backgroundColor: "#41589f",
            //  marginRight:'200px',
            //  marginLeft:'200px',
            marginTop: "30px",
            marginBottom: "10px",
            borderRadius: "4px",
            border: "1px solid #41589f",
      },
})

class MySweetContentManager extends Component {
      cookies = new Cookies()
      paramsCounter = 0
      regex = new RegExp("^[-a-zA-Z0-9/،?=آ-ی .:_-]+$");
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  smsList : [],
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  content : "",
                  route : "",
                  selectedId : -1,
                  contents: []

            }
      }

      saveContent = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "success"})
                              self.getAll();
                        }
                        else if (arr.result === "error") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "error"})
                              return false;
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "create")
            fd.append("route", this.state.route)
            fd.set("content", JSON.stringify({content: self.state.content}))

            xhttp.open("POST", `${constants.BASE_URL}ContentManager`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)

      }




      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }
      reset(){
            this.paramsCounter = 0;
            this.setState({
                  content : "",
                  route: "",
                  selectedId : -1,
            })
      }

      update(){
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "success"})
                              self.getAll();

                        }
                        else if (arr.result === "error") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "error"})
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "update")
            fd.append("id", this.state.selectedId)
            fd.set("content", JSON.stringify({content: self.state.content}))
            fd.append("route", this.state.route)

            xhttp.open("POST", `${constants.BASE_URL}ContentManager`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      handleClickOnSmsRow = (content) => {

            this.setState({
                  content :  content.content_manager_content,
                  route : content.content_manager_route,
                  selectedId: content.content_manager_id,
            })
      }


      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }
      getAll = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({contents : arr.data }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "getAll")
            xhttp.open("POST", `${constants.BASE_URL}ContentManager`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    /*
                                          SHOULD BE RELACED
                                     */
                                    self.getAll();

                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }
      createMarkup()  {
      return {__html: this.state.content};
}

      render() {
            const self = this

            const { classes } = this.props
            const {
                  redirect,
                  showSnack,
                  snackMode,
                  snackstr,
                  content,
                  route


            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (

                  <Container style={{padding: "10px"}}>
                        <TextField
                            style={{padding: "10px"}}
                            id="standard-basic"
                            value={route}
                            label="آدرس"
                            onChange={e => this.setState({route: e.target.value})}
                            variant="standard"
                        />
                        <Editor
                            apiKey='si37caopxhb5c937cgngpduh55jrko29wv9yigj4ftzdix5k'

                            init={{
                                  plugins: 'ai tinycomments mentions anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed permanentpen footnotes advtemplate advtable advcode editimage tableofcontents mergetags powerpaste tinymcespellchecker autocorrect a11ychecker typography inlinecss',
                                  toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | align lineheight | tinycomments | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                                  tinycomments_mode: 'embedded',
                                  tinycomments_author: 'Author name',
                                  mergetags_list: [
                                        { value: 'First.Name', title: 'First Name' },
                                        { value: 'Email', title: 'Email' },
                                  ],
                                  ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
                            }}
                            value={content}
                            id="editor"
                            onEditorChange={e=>this.setState({content: e})}
                            language = "fa"


                        />
                       

                        <Snackbar
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            onClose={this.handleClickcloseTasckBar}
                            open={showSnack}
                            autoHideDuration={10000}
                        >
                              <Alert severity={snackMode}>{snackstr}</Alert>
                        </Snackbar>

                        {(this.state.selectedId < 0) ?
                                  <Button style={{padding: "10px"}} variant="outlined" color="primary"
                                          onClick={()=>this.saveContent()}>
                                        {"ایجاد محتوا"}
                                  </Button>

                            :
                                  <Button style={{padding: "10px"}} variant="outlined" color="primary"
                                          onClick={() => this.update()}>
                                        {"تغییر محتوا"}
                                  </Button>

                        }
                        <Button style={{padding: "10px"}} variant="outlined" color="primary"
                                onClick={() => this.reset()}>
                              {"ریست"}
                        </Button>
                        <div>
                              <h1>محتوای رندر شده را در این قسمت مشاهده کنید</h1>
                              <div dangerouslySetInnerHTML={this.createMarkup()} ></div>
                        </div>
                        <Grid container style={{padding: "20px"}} spacing={3}>
                              <Grid item xs={12}>
                                    <Container maxWidth="lg">
                                          <Paper className={classes.root}>
                                                <TableContainer dir="rtl">
                                                      <Table aria-label="sticky table">
                                                            <TableHead>
                                                                  <TableRow>
                                                                        <TableCell
                                                                            key={"sms_id"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}
                                                                        >
                                                                              {" شماره محتوا "}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            key={"sms_activation"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}

                                                                        >
                                                                              {"ادرس "}

                                                                        </TableCell>



                                                                  </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                        {this.state.contents.map((content) =>{
                                                                              return (
                                                                                <TableRow
                                                                                onClick={() => this.handleClickOnSmsRow(content)}>
                                                                                      <TableCell
                                                                                          key={"id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {content.content_manager_id}
                                                                                      </TableCell>
                                                                                      <TableCell
                                                                                          key={"route"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {content.content_manager_route}
                                                                                      </TableCell>

                                                                                </TableRow>
                                                                              );
                                                                        })}
                                                                  </TableBody>
                                                      </Table>
                                                </TableContainer>
                                          </Paper>
                                    </Container>
                              </Grid>

                     </Grid>
                  </Container>

                  )
            }
      }
}

export default withStyles(styles)(MySweetContentManager)
